/* RESPONSIBLE TEAM: team-messenger */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    spacesForUsers: { embedded: 'always' },
    spacesForVisitors: { embedded: 'always' },
    spacesForMobileUsers: { embedded: 'always' },
  },
});
